import { atom, useAtomValue, useSetAtom } from 'jotai'

export type Bounds = {
  x: number
  y: number
  width: number
  height: number
}

const interactiveElementsAtom = atom<Record<string, Bounds>>({})
const debugAtom = atom<boolean>(false)

export const useDebugInteractivity = () => {
  return useAtomValue(debugAtom)
}

export const useSetDebugInteractivity = () => {
  return useSetAtom(debugAtom)
}

export const useInteractiveElements = () => {
  return useAtomValue(interactiveElementsAtom)
}

export const useSetInteractiveElements = () => {
  return useSetAtom(interactiveElementsAtom)
}
